import styled from 'styled-components';

export default styled.div`
  float: right;
  margin-top: 7px;
`;
